export const BrowserDefenderGenerations = {
  legacy: "eohnjdeamkjliemanljkkjcepdfgcggl",
  enterprise: "hpdgaogjloaccgpbbncjmedlakljfegb",
};
